import { createAction } from "@reduxjs/toolkit";

export const initializeApp = createAction("APP_INIT");
